import { useMemo } from "react";
import { GiRingingBell } from "react-icons/gi";
import useAvailability from "../../../hooks/useAvailability";
import { useSession } from "../../Atoms/AppSession";
import styles from "./HurryUpMessage.module.scss";

type HurryUpMessageProps = Pick<
  ReturnType<typeof useAvailability>,
  "isAvailableInRange"
>;

export default function HurryUpMessage({
  isAvailableInRange,
}: HurryUpMessageProps) {
  const session = useSession();
  const { countryCode } = session;

  const isProductAvailableSoon = useMemo(
    () =>
      isAvailableInRange({
        duration: { days: 2 },
      }),
    [isAvailableInRange]
  );

  return (
    <>
      {countryCode === "Asia/Tokyo" && isProductAvailableSoon ? (
        <div className={styles["HurryUpMessage"]}>
          <GiRingingBell
            size={24}
            color={"#009788"}
            style={{
              flexShrink: 0,
              position: "relative",
              top: 2,
              right: 2,
            }}
          />
          <span>
            Tours within 3 days are available! Hurry! Secure your spot before it
            fills up!
          </span>
        </div>
      ) : null}
    </>
  );
}
